import { ReactElement } from 'react';
import { MaterialIcon } from '@tap/mui-ui';
import { Tooltip } from '@mui/material';
import React from 'react';
import { TapPriority, TapPriorityList } from '@tap/tap-ui';

export const PriorityFieldCell = ({
    value,
}: {
    value?: string,
}): ReactElement<any, any> => {
    const priority = TapPriorityList.find(p => p.code === (value || TapPriority.Low));

    if (!priority)
        return <>-</>; //TODO: remove this case. REsolve type issues;

    return (
        <Tooltip title={priority.name}>
            <div>
                <MaterialIcon iconName={priority.icon.name}
                    sx={{ color: priority.icon.color, fontSize: '20px' }} />
            </div>
        </Tooltip>
    )
};
